module.exports = __webpack_public_path__ + "static/media/checked.7d8eb9ac.svg";